import { render, staticRenderFns } from "./home.page.vue?vue&type=template&id=722da2b2"
import script from "./home.page.vue?vue&type=script&lang=js"
export * from "./home.page.vue?vue&type=script&lang=js"
import style0 from "./home.page.vue?vue&type=style&index=0&id=722da2b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports